export const isNaN = function(value) {
  const n = Number(value);
  return n !== n;
};
